import type { Reference } from '@medplum/fhirtypes'
import { invariant } from '@seen/core/invariant'
import { parseReferenceString } from '@seen/core/utils'

export function extractMentionReferences(html: string): Reference[] {
  const doc = new DOMParser().parseFromString(html, 'text/html')
  const mentions = doc.querySelectorAll(`[data-reference]`)
  return Array.from(mentions).map((mention) => {
    const reference = parseReferenceString(
      mention.getAttribute('data-reference'),
      mention.textContent
    )
    invariant(reference, 'Reference is required')
    return reference
  })
}
